import type { Step } from "react-joyride";

export const ratesTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າອັດຕາຄ່າສົ່ງ. ຫນ້ານີ້ຊ່ວຍທ່ານຈັດການອັດຕາຄ່າສົ່ງຕາມໂຊນ ແລະ ນ້ຳໜັກໄດ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="shipping-rates-toolbar"]',
    content: "ປຸ່ມສ້າງອັດຕາຄ່າສົ່ງໃໝ່. ກົດເພື່ອເພີ່ມອັດຕາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-rates-filter"]',
    content: "ກອງຕາມໂຊນ. ເລືອກໂຊນເພື່ອກອງອັດຕາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-rates-table"]',
    content: "ຕາຕະລາງອັດຕາຄ່າສົ່ງ. ສາມາດແກ້ໄຂ ຫຼື ລຶບໄດ້ຈາກປຸ່ມການກະທໍາ.",
    placement: "top",
  },
];
